import React, { Component } from "react";
import {
  Button,
  Container,
  Row,
  Form,
  Col,
  Offcanvas,
  Badge,
  Modal,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";
import { ValidationUtils } from "../Sidebar/Common";

export default class Deploymentapprovals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.deploymentapprovals_Id,
          sortable: true,
          cell: (row) => <span>{row.deploymentapprovals_Id}</span>,
        },
        {
          name: "Deployment Request Id",
          selector: (row, i) => row.deploymentRequest_Id,
          sortable: true,
          cell: (row) => <span>{row.deploymentRequest_Id}</span>,
        },
        {
          name: "Approver Id",
          selector: (row, i) => row.approverId,
          sortable: true,
          cell: (row) => <span>{row.approverId}</span>,
        },
        {
          name: "Approval Status",
          selector: (row, i) => row.approvalStatus,
          sortable: true,
          cell: (row) => <span>{row.approvalStatus}</span>,
        },
        {
          name: "Approval Remarks",
          selector: (row, i) => row.approvalRemarks,
          sortable: true,
          cell: (row) => <span>{row.approvalRemarks}</span>,
        },
        {
          name: "Approved On",
          selector: (row, i) => row.approvedOn,
          sortable: true,
          cell: (row) => <span>{row.approvedOn}</span>,
        },
        {
          name: "Type",
          selector: (row, i) => row.requestType,
          sortable: true,
          cell: (row) => (
            <Badge bg={row.requestType === "UI" ? "primary" : "success"}>
              {row.requestType || "N/A"}
            </Badge>
          ),
        },
        {
          name: "Project",
          selector: (row, i) => row.projectName,
          sortable: true,
          cell: (row) => <span>{row.projectName || ""}</span>,
        },
        {
          name: "Stage",
          selector: (row, i) => row.currentStage,
          sortable: true,
          cell: (row) => (
            <Badge
              bg={
                row.currentStage === "PendingTLApproval"
                  ? "info"
                  : row.currentStage === "PendingManagerApproval"
                    ? "warning"
                    : row.approvalStatus === "Approved"
                      ? "success"
                      : row.approvalStatus === "Rejected"
                        ? "danger"
                        : "secondary"
              }
            >
              {row.approvalStatus || row.currentStage || ""}
            </Badge>
          ),
        },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {(!row.approvalStatus || row.approvalStatus === "Pending") && (
                <>
                  <Button
                    style={{ marginRight: "5px" }}
                    variant="success"
                    size="sm"
                    onClick={() => this.handleApproveClick(row)}
                  >
                    Approve
                  </Button>
                  <Button
                    style={{ marginRight: "5px" }}
                    variant="danger"
                    size="sm"
                    onClick={() => this.handleRejectClick(row)}
                  >
                    Reject
                  </Button>
                </>
              )}
              <Button
                style={{ marginRight: "5px" }}
                variant="primary"
                size="sm"
                onClick={() => this.DeploymentapprovalseditHandler(row)}
                className="bi bi-pen"
              ></Button>
              <Button
                variant="danger"
                size="sm"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],
      allRequests: [],
      pendingColumns: [
        {
          name: "S.NO",
          selector: (row, i) => Number(row.deploymentrequests_Id),
          sortable: true,
          cell: (row) => <span>{row.deploymentrequests_Id}</span>,
        },
        {
          name: "Request Code",
          selector: (row) => row.requestCode,
          sortable: true,
        },
        {
          name: "Project",
          selector: (row) => row.projectName,
          sortable: true,
        },
        {
          name: "Type",
          selector: (row) => row.requestType,
          cell: (row) => (
            <Badge bg={row.requestType === "UI" ? "primary" : "success"}>
              {row.requestType || "N/A"}
            </Badge>
          ),
        },
        {
          name: "Stage",
          selector: (row) => row.currentStage,
          sortable: true,
          cell: (row) => {
            const stageMap = {
              PendingTLApproval: { label: "Pending TL", bg: "info" },
              PendingManagerApproval: {
                label: "Pending Manager",
                bg: "warning",
              },
              ReadyForDeployment: { label: "Ready to Deploy", bg: "primary" },
              Deploying: { label: "Deploying", bg: "warning" },
              Deployed: { label: "Deployed", bg: "success" },
              Rejected: { label: "Rejected", bg: "danger" },
              Failed: { label: "Failed", bg: "danger" },
              RolledBack: { label: "Rolled Back", bg: "dark" },
            };
            const info = stageMap[row.currentStage] || {
              label: row.currentStage || "Draft",
              bg: "secondary",
            };
            return <Badge bg={info.bg}>{info.label}</Badge>;
          },
        },
        {
          name: "Reason",
          selector: (row) => row.reasonForDeployment,
          wrap: true,
        },
        {
          name: "Actions",
          cell: (row) => {
            const isPending =
              row.currentStage === "PendingTLApproval" ||
              row.currentStage === "PendingManagerApproval";
            return (
              <div>
                <Button
                  size="sm"
                  variant="info"
                  className="me-1"
                  style={{ padding: "4px 9px" }}
                  onClick={() => this.handlePreviewRequest(row)}
                >
                  Preview
                </Button>
                {isPending && (
                  <>
                    <Button
                      size="sm"
                      variant="success"
                      className="me-1"
                      style={{
                        padding: "7px 9px",
                        marginTop: "0px",
                        height: "28px",
                      }}
                      onClick={() => this.handleApproveRequest(row)}
                    >
                      Approve
                    </Button>
                    <Button
                      size="sm"
                      variant="danger"
                      style={{
                        padding: "7px 9px",
                        marginTop: "0px",
                        height: "28px",
                      }}
                      onClick={() => this.handleRejectClick(row)}
                    >
                      Reject
                    </Button>
                  </>
                )}
              </div>
            );
          },
          width: "280px",
        },
      ],
      // Preview modal
      showPreviewModal: false,
      previewRequest: null,
      previewFiles: [],
      previewPackages: [],
      employees: [],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      deploymentapprovals_Id: "",
      deploymentRequest_Id: "",
      approverId: "",
      approvalStatus: "",
      approvalRemarks: "",
      approvedOn: "",
      approverRole: "",
      requestType: "",
      // Reject modal
      showRejectModal: false,
      rejectRequestId: "",
      rejectRemarks: "",
      activeTab: "pending",
      //***state
    };
  }
  // Format a yyyy-mm-dd (optionally with time) value to dd/mm/yyyy
  formatDate = (dateString) => {
    if (!dateString || dateString === "-") return "-";
    const datePart = String(dateString).split(/[ T]/)[0];
    if (datePart.includes("-")) {
      const [year, month, day] = datePart.split("-");
      if (year && month && day) return `${day}/${month}/${year}`;
    }
    return dateString;
  };

  // Format a "yyyy-mm-dd HH:mm:ss" value to "dd-mm-yyyy HH:mm:ss"
  formatDateTime = (value) => {
    if (!value || value === "-") return "-";
    const [datePart, timePart = ""] = String(value).split(/[ T]/);
    let out = datePart;
    if (datePart.includes("-")) {
      const [year, month, day] = datePart.split("-");
      if (year && month && day) out = `${day}-${month}-${year}`;
    }
    return timePart ? `${out} ${timePart.slice(0, 8)}` : out;
  };
  getPendingAtInfo = (row) => {
    const stage = row.currentStage;
    if (stage === "PendingTLApproval")
      return { label: "Pending At", name: row.teamLeadName || "-" };
    if (stage === "PendingManagerApproval")
      return { label: "Pending At", name: row.managerName || "-" };
    if (stage === "ReadyForDeployment" || stage === "Deploying")
      return { label: "Pending At", name: row.assigneeName || "-" };
    if (stage === "Deployed")
      return { label: "Deployed By", name: row.deployedByName || "-" };
    return { label: "Pending At", name: "-" };
  };
  // Render a comma-separated string as a point-wise (bulleted) list
  renderList = (value) => {
    if (!value) return "-";
    const items = String(value)
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean);
    if (items.length === 0) return "-";
    return (
      <ul className="mb-0 ps-3">
        {items.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    );
  };
  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case "text":
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(
            value,
            parseInt(validationOptions.maxLength),
            fieldDisplayName,
          );
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case "mail":
      case "email":
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case "telephone":
      case "phone":
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case "number":
        validationResult = ValidationUtils.validateNumber(
          value,
          fieldDisplayName,
        );
        break;

      case "dob_child":
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case "dob_adult":
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case "pan":
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case "aadhaar":
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case "password":
        if (value.length < 6) {
          validationResult = {
            isValid: false,
            message: "Password must be at least 6 characters long",
          };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (
      validationOptions?.isRequired &&
      (!value || value.toString().trim() === "")
    ) {
      validationResult = ValidationUtils.validateRequired(
        value,
        fieldDisplayName,
      );
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true },
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true },
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined

    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      {
        fieldName: "deploymentRequest_Id",
        inputType: "Number",
        displayName: "Deployment Request Id",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "approverId",
        inputType: "Number",
        displayName: "Approver Id",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "approvalStatus",
        inputType: "Text",
        displayName: "Approval Status",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "approvalRemarks",
        inputType: "Text",
        displayName: "Approval Remarks",
        validationOptions: { isRequired: false },
      },
      {
        fieldName: "approvedOn",
        inputType: "Date",
        displayName: "Approved On",
        validationOptions: { isRequired: false },
      },
    ];

    fieldConfigs.forEach((config) => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach((config) => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });
  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      deploymentRequest_Id: "",
      approverId: "",
      approvalStatus: "",
      approvalRemarks: "",
      approvedOn: "",
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      deploymentRequest_Id: "",
      approverId: "",
      approvalStatus: "",
      approvalRemarks: "",
      approvedOn: "",
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  DeploymentapprovalseditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      deploymentapprovals_Id: row.deploymentapprovals_Id,
      deploymentRequest_Id: row.deploymentRequest_Id,
      approverId: row.approverId,
      approvalStatus: row.approvalStatus,
      approvalRemarks: row.approvalRemarks,
      approvedOn: row.approvedOn,
      //***editstate
      errors: {},
      touched: {},
    });
  };

  DeploymentapprovalsfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Deploymentapprovals/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  };

  DeploymentapprovalssubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("deploymentRequest_Id", this.state.deploymentRequest_Id);
    formData.append("approverId", this.state.approverId);
    formData.append("approvalStatus", this.state.approvalStatus);
    formData.append("approvalRemarks", this.state.approvalRemarks);
    formData.append("approvedOn", this.state.approvedOn);

    //***tableData*

    fetch(configData.api_url + "C_Deploymentapprovals/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.DeploymentapprovalsfetchHandler();
          this.handleOffcanvasClose();
          this.setState({
            deploymentRequest_Id: "",
            approverId: "",
            approvalStatus: "",
            approvalRemarks: "",
            approvedOn: "",
          });
        }
      })
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      });
  };

  DeploymentapprovalsupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append(
      "deploymentapprovals_Id",
      this.state.deploymentapprovals_Id,
    );
    formData.append("deploymentRequest_Id", this.state.deploymentRequest_Id);
    formData.append("approverId", this.state.approverId);
    formData.append("approvalStatus", this.state.approvalStatus);
    formData.append("approvalRemarks", this.state.approvalRemarks);
    formData.append("approvedOn", this.state.approvedOn);

    //***tableData1

    fetch(configData.api_url + "C_Deploymentapprovals/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.DeploymentapprovalsfetchHandler();
          this.handleOffcanvasClose();
        }
      })
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      });
  };

  componentDidMount() {
    this.DeploymentapprovalsfetchHandler();
    this.fetchAllRequests();
    this.fetchEmployees();

    //***componentDidMount
  }

  fetchEmployees = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Employees/list", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ employees: data.list || [] });
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  // Resolve the "Requested By" display: prefer a name that's already text,
  // otherwise look the numeric id up in the employees list.
  getRequesterName = (request) => {
    if (!request) return "-";
    const raw = request.requesterName || request.requestedBy;
    if (!raw && raw !== 0) return "-";
    // If it's already a non-numeric string (a name), show it as-is.
    if (isNaN(raw)) return raw;
    // Otherwise treat it as an employee id and resolve to a name.
    const emp = this.state.employees.find(
      (e) => String(e.employees_Id) === String(raw),
    );
    if (emp) {
      const name = `${emp.fName || ""} ${emp.lName || ""}`.trim();
      if (name) return name;
    }
    return request.requesterName || raw;
  };

  fetchAllRequests = () => {
    const frmdata = new FormData();
    frmdata.append("sId", this.state.sId);
    fetch(configData.api_url + "C_Deploymentrequests/listAllForApprover", {
      method: "POST",
      body: frmdata,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const sorted = [...(data.list || [])].sort(
            (a, b) =>
              Number(b.deploymentrequests_Id || 0) -
              Number(a.deploymentrequests_Id || 0),
          );
          this.setState({ allRequests: sorted });
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  handleApproveRequest = (row) => {
    const frmdata = new FormData();
    frmdata.append("sId", this.state.sId);
    frmdata.append("deploymentRequest_Id", row.deploymentrequests_Id);
    frmdata.append("approvalRemarks", "Approved");
    // Detect stage to set correct approverRole
    const stage = row.currentStage || "";
    let approverRole = row.requestType === "UI" ? "UITeamLead" : "APITeamLead";
    if (stage === "PendingManagerApproval") {
      approverRole = "Manager";
    }
    frmdata.append("approverRole", approverRole);
    frmdata.append("requestType", row.requestType || "");

    fetch(configData.api_url + "C_Deploymentapprovals/approve", {
      method: "POST",
      body: frmdata,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          toast.success(data.message || "Request approved successfully");
          this.fetchAllRequests();
          this.DeploymentapprovalsfetchHandler();
        } else {
          toast.error(data.message);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error("Failed to approve request");
      });
  };

  handleApproveClick = (row) => {
    this.handleApproveRequest({
      deploymentrequests_Id: row.deploymentRequest_Id,
      requestType: row.requestType,
    });
  };

  handleRejectClick = (row) => {
    this.setState({
      showRejectModal: true,
      rejectRequestId: row.deploymentRequest_Id || row.deploymentrequests_Id,
      rejectRemarks: "",
    });
  };

  handleRejectConfirm = () => {
    if (!this.state.rejectRemarks.trim()) {
      toast.warning("Please enter rejection comments");
      return;
    }

    const frmdata = new FormData();
    frmdata.append("sId", this.state.sId);
    frmdata.append("deploymentRequest_Id", this.state.rejectRequestId);
    frmdata.append("approvalRemarks", this.state.rejectRemarks);

    fetch(configData.api_url + "C_Deploymentapprovals/reject", {
      method: "POST",
      body: frmdata,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          toast.success("Request rejected");
          this.setState({ showRejectModal: false, rejectRemarks: "" });
          this.fetchAllRequests();
          this.DeploymentapprovalsfetchHandler();
        } else {
          toast.error(data.message);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error("Failed to reject request");
      });
  };

  handlePreviewRequest = (row) => {
    const requestId = row.deploymentrequests_Id || row.deploymentRequest_Id;
    this.setState({
      showPreviewModal: true,
      previewRequest: row,
      previewFiles: [],
      previewPackages: [],
    });

    // Fetch files for this request
    const frmFiles = new FormData();
    frmFiles.append("sId", this.state.sId);
    fetch(configData.api_url + "C_Deploymentfiles/list", {
      method: "POST",
      body: frmFiles,
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status === "success") {
          const files = (data.list || []).filter(
            (f) => String(f.deploymentRequest_Id) === String(requestId),
          );
          this.setState({ previewFiles: files });
        }
      })
      .catch((e) => console.error(e));

    // Fetch packages for this request
    const frmPkg = new FormData();
    frmPkg.append("sId", this.state.sId);
    fetch(configData.api_url + "C_Deploymentpackages/list", {
      method: "POST",
      body: frmPkg,
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status === "success") {
          const pkgs = (data.list || []).filter(
            (p) => String(p.deploymentRequest_Id) === String(requestId),
          );
          this.setState({ previewPackages: pkgs });
        }
      })
      .catch((e) => console.error(e));
  };

  handledeploymentRequest_IdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ deploymentRequest_Id: fieldValue });
  };
  handleapproverIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ approverId: fieldValue });
  };
  handleapprovalStatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ approvalStatus: fieldValue });
  };
  handleapprovalRemarksChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ approvalRemarks: fieldValue });
  };
  handleapprovedOnChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ approvedOn: fieldValue });
  };
  //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (
      !window.confirm(
        `Are you sure you want to delete this deploymentapprovals?`,
      )
    ) {
      return;
    }

    var formData = new FormData();
    formData.append("deploymentapprovals_Id", row.deploymentapprovals_Id);

    fetch(configData.api_url + "C_Deploymentapprovals/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.DeploymentapprovalsfetchHandler();
        }
      })
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } =
      fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError =
      this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case "dob_child":
      case "dob_adult":
      case "date":
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case "telephone":
      case "phone":
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case "mail":
      case "email":
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case "password":
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case "number":
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case "pan":
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(
                fieldName,
                e.target.value.toUpperCase(),
                fieldConfig,
              )
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case "aadhaar":
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(
                fieldName,
                e.target.value.replace(/\D/g, ""),
                fieldConfig,
              )
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) =>
              this.handleFieldChange(fieldName, e.target.value, fieldConfig)
            }
            onBlur={(e) =>
              this.handleFieldBlur(fieldName, e.target.value, fieldConfig)
            }
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && (
              <span className="text-danger">*</span>
            )}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage,
        )
      : this.state.data.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage,
        );

    return (
      <div className="page-title">
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3
                        className="logoskybluecolor"
                        style={{ textAlign: "start" }}
                      >
                        Deployment Approvals
                      </h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary"
                        style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>
                            Add Deploymentapprovals
                          </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>
                                  Please fix the following errors:
                                </strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(
                                    ([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ),
                                  )}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Deployment Request Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={
                                          this.handledeploymentRequest_IdChange
                                        }
                                        className="form-control"
                                        name="deploymentRequest_Id"
                                        value={this.state.deploymentRequest_Id}
                                        required="required"
                                        placeholder="Enter Deployment Request Id"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {
                                        this.state.errors.deploymentRequest_Id
                                      }{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Approver Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={this.handleapproverIdChange}
                                        className="form-control"
                                        name="approverId"
                                        value={this.state.approverId}
                                        required="required"
                                        placeholder="Enter Approver Id"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.approverId}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Approval Status
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Select
                                        className="form-select"
                                        onChange={
                                          this.handleapprovalStatusChange
                                        }
                                        name="approvalStatus"
                                        value={this.state.approvalStatus}
                                        required="required"
                                        placeholder="Enter Approval Status"
                                      >
                                        <option value="">Select</option>
                                        <option value="Approved">
                                          Approved
                                        </option>
                                        <option value="Rejected">
                                          Rejected
                                        </option>
                                      </Form.Select>
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.approvalStatus}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Approval Remarks
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handleapprovalRemarksChange
                                        }
                                        className="form-control"
                                        name="approvalRemarks"
                                        value={this.state.approvalRemarks}
                                        required="required"
                                        placeholder="Enter Approval Remarks"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.approvalRemarks}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Approved On
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="date"
                                        onChange={this.handleapprovedOnChange}
                                        className="form-control"
                                        name="approvedOn"
                                        value={this.state.approvedOn}
                                        required="required"
                                        placeholder="Enter Approved On"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.approvedOn}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  {/* tableContent */}
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "30px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={
                                    this.DeploymentapprovalssubmitHandler
                                  }
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>
                              Edit Deploymentapprovals
                            </Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container
                              style={{ overflowY: "auto", height: "auto" }}
                            >
                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>
                                    Please fix the following errors:
                                  </strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(
                                      ([field, error]) => (
                                        <li key={field}>{error}</li>
                                      ),
                                    )}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Deployment Request Id
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={
                                            this
                                              .handledeploymentRequest_IdChange
                                          }
                                          className="form-control"
                                          name="deploymentRequest_Id"
                                          value={
                                            this.state.deploymentRequest_Id
                                          }
                                          required="required"
                                          placeholder="Enter Deployment Request Id"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.deploymentRequest_Id
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Approver Id
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={this.handleapproverIdChange}
                                          className="form-control"
                                          name="approverId"
                                          value={this.state.approverId}
                                          required="required"
                                          placeholder="Enter Approver Id"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.approverId}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Approval Status
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Select
                                          className="form-select"
                                          onChange={
                                            this.handleapprovalStatusChange
                                          }
                                          name="approvalStatus"
                                          value={this.state.approvalStatus}
                                          required="required"
                                          placeholder="Enter Approval Status"
                                        >
                                          <option value="">Select</option>
                                          <option value="Approved">
                                            Approved
                                          </option>
                                          <option value="Rejected">
                                            Rejected
                                          </option>
                                        </Form.Select>
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.approvalStatus}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Approval Remarks
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleapprovalRemarksChange
                                          }
                                          className="form-control"
                                          name="approvalRemarks"
                                          value={this.state.approvalRemarks}
                                          required="required"
                                          placeholder="Enter Approval Remarks"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.approvalRemarks}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Approved On
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="date"
                                          onChange={this.handleapprovedOnChange}
                                          className="form-control"
                                          name="approvedOn"
                                          value={this.state.approvedOn}
                                          required="required"
                                          placeholder="Enter Approved On"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.approvedOn}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    {/* tableContent */}
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={
                                      this.DeploymentapprovalsupdateHandler
                                    }
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        columns={this.state.pendingColumns}
                        data={this.state.allRequests}
                        pagination
                        defaultSortFieldId={1}
                        defaultSortAsc={false}
                        highlightOnHover
                        striped
                        noDataComponent="No requests found"
                        keyField="deploymentrequests_Id"
                        paginationPerPage={100}
                        paginationRowsPerPageOptions={[
                          100, 200, 300, 400, 500, 600, 700, 800, 900, 1000,
                        ]}
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Preview Modal */}
        <Modal
          show={this.state.showPreviewModal}
          onHide={() => this.setState({ showPreviewModal: false })}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Deployment Request Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.previewRequest && (
              <>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Request Code:</strong>{" "}
                    {this.state.previewRequest.requestCode}
                  </Col>
                  <Col md="6">
                    <strong>Project:</strong>{" "}
                    {this.state.previewRequest.projectName}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Type:</strong>{" "}
                    <Badge
                      bg={
                        this.state.previewRequest.requestType === "UI"
                          ? "primary"
                          : "success"
                      }
                    >
                      {this.state.previewRequest.requestType || "N/A"}
                    </Badge>
                  </Col>
                  <Col md="6">
                    <strong>Stage:</strong>{" "}
                    <Badge bg="info">
                      {this.state.previewRequest.currentStage || "N/A"}
                    </Badge>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Target Environment:</strong>{" "}
                    {this.state.previewRequest.targetEnvironment || "-"}
                  </Col>
                  <Col md="6">
                    <strong>Action Type:</strong>{" "}
                    {this.state.previewRequest.actionType || "-"}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Priority:</strong>{" "}
                    {this.state.previewRequest.priority || "-"}
                  </Col>
                  <Col md="6">
                    <strong>Request Date:</strong>{" "}
                    {this.formatDate(
                      this.state.previewRequest.requestDate || "-",
                    )}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Requested By:</strong>{" "}
                    {this.getRequesterName(this.state.previewRequest)}
                  </Col>
                  <Col md="6">
                    <strong>Created Date:</strong>{" "}
                    {this.formatDateTime(this.state.previewRequest.createdOn)}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Reason for Deployment:</strong>
                    <br />
                    {this.state.previewRequest.reasonForDeployment || "-"}
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Remarks:</strong>
                    <br />
                    {this.state.previewRequest.remarks || "-"}
                  </Col>
                  <Col md="6">
                    {(() => {
                      const info = this.getPendingAtInfo(
                        this.state.previewRequest,
                      );
                      return (
                        <>
                          <strong>{info.label}:</strong>{" "}
                          <Badge
                            bg={
                              info.label === "Deployed By"
                                ? "success"
                                : "warning"
                            }
                          >
                            {info.name}
                          </Badge>
                        </>
                      );
                    })()}
                  </Col>
                </Row>

                {/* Deployment Files */}
                <hr />
                <h6>Deployment Files</h6>
                {this.state.previewFiles.length > 0 ? (
                  <DataTable
                    columns={[
                      {
                        name: "File Name",
                        selector: (r) => r.fileName,
                        wrap: true,
                        cell: (r) => this.renderList(r.fileName),
                      },
                      {
                        name: "File Path",
                        selector: (r) => r.filePath,
                        wrap: true,
                        cell: (r) => this.renderList(r.filePath),
                      },
                      { name: "Version", selector: (r) => r.version },
                      {
                        name: "Status",
                        selector: (r) => r.deploymentFilestatus,
                        cell: (r) => (
                          <Badge
                            bg={
                              r.deploymentFilestatus === "Done"
                                ? "success"
                                : "secondary"
                            }
                          >
                            {r.deploymentFilestatus || "-"}
                          </Badge>
                        ),
                      },
                    ]}
                    data={this.state.previewFiles}
                    noDataComponent="No files"
                    dense
                    striped
                  />
                ) : (
                  <p className="text-muted">No files attached</p>
                )}

                {/* Deployment Packages */}
                <hr />
                <h6>Deployment Packages</h6>
                {this.state.previewPackages.length > 0 ? (
                  <DataTable
                    columns={[
                      {
                        name: "Package Name",
                        selector: (r) => r.packageName,
                        wrap: true,
                      },
                      { name: "Version", selector: (r) => r.version },
                      { name: "Build #", selector: (r) => r.buildNumber },
                      { name: "Type", selector: (r) => r.packageType },
                    ]}
                    data={this.state.previewPackages}
                    noDataComponent="No packages"
                    dense
                    striped
                  />
                ) : (
                  <p className="text-muted">No packages attached</p>
                )}
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            {this.state.previewRequest &&
              (this.state.previewRequest.currentStage === "PendingTLApproval" ||
                this.state.previewRequest.currentStage ===
                  "PendingManagerApproval") && (
                <>
                  <Button
                    size="sm"
                    variant="success"
                    className="me-1"
                    style={{ padding: "10px 10px", marginTop: "5px" }}
                    onClick={() => {
                      this.setState({ showPreviewModal: false });
                      this.handleApproveRequest(this.state.previewRequest);
                    }}
                  >
                    Approve
                  </Button>
                  <Button
                    size="sm"
                    variant="danger"
                    style={{ padding: "10px 14px" }}
                    onClick={() => {
                      this.setState({ showPreviewModal: false });
                      this.handleRejectClick(this.state.previewRequest);
                    }}
                  >
                    Reject
                  </Button>
                </>
              )}
            <Button
              variant="secondary"
              onClick={() => this.setState({ showPreviewModal: false })}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Reject Modal */}
        <Modal
          show={this.state.showRejectModal}
          onHide={() => this.setState({ showRejectModal: false })}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Reject Deployment Request</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.Label>
                <strong>Rejection Comments (Required)</strong>
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                value={this.state.rejectRemarks}
                onChange={(e) =>
                  this.setState({ rejectRemarks: e.target.value })
                }
                placeholder="Please provide a reason for rejecting this deployment request..."
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              size="sm"
              variant="secondary"
              style={{ padding: "10px 14px" }}
              onClick={() => this.setState({ showRejectModal: false })}
            >
              Cancel
            </Button>
            <Button
              size="sm"
              variant="danger"
              style={{ padding: "10px 14px" }}
              onClick={this.handleRejectConfirm}
            >
              Confirm Rejection
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
